import React from 'react';
import { FolderOutlined } from '@ant-design/icons';
import { getItem } from '../../util';

export const FE7Items = getItem('FE7', 'FE7', <FolderOutlined />, [
  getItem('AI Recruitment Editor', 'FE7/AIRecruitmentEditor'),
  getItem('AI Recruitment Editor P2', 'FE7/AIRecruitmentEditorP2'),
  getItem('Assassin Legault Custom Animation Editor', 'FE7/AssassinLegaultCustomAnimationEditor'),
  getItem('Battle screen editor part 1', 'FE7/Battlescreeneditorpart1'),
  getItem('Battle screen editor part 2', 'FE7/Battlescreeneditorpart2'),
  getItem('Battle screen editor part 3', 'FE7/Battlescreeneditorpart3'),
  getItem('Battle screen editor part 4', 'FE7/Battlescreeneditorpart4'),
  getItem('Battle screen editor part 5', 'FE7/Battlescreeneditorpart5'),
  getItem('Blessing of the Eight Generals Editor', 'FE7/BlessingoftheEightGeneralsEditor'),
  getItem('Chapter 1 Table Editor', 'FE7/Chapter1TableEditor'),
  getItem('Chapter 1 Unit Editor', 'FE7/Chapter1UnitEditor'),
  getItem('Chapter 10 Armoury Editor', 'FE7/Chapter10ArmouryEditor'),
  getItem('Chapter 10 Seize Editor', 'FE7/Chapter10SeizeEditor'),
  getItem('Chapter 10 Shop Editor', 'FE7/Chapter10ShopEditor'),
  getItem('Chapter 10 Table Editor', 'FE7/Chapter10TableEditor'),
  getItem('Chapter 10 Unit Editor', 'FE7/Chapter10UnitEditor'),
  getItem('Chapter 11 Seize Editor', 'FE7/Chapter11SeizeEditor'),
  getItem('Chapter 11 Shop Editor', 'FE7/Chapter11ShopEditor'),
  getItem('Chapter 11 Table Editor', 'FE7/Chapter11TableEditor'),
  getItem('Chapter 11 Unit Editor', 'FE7/Chapter11UnitEditor'),
  getItem('Chapter 11H Table Editor', 'FE7/Chapter11HTableEditor'),
  getItem('Chapter 11H Unit Editor', 'FE7/Chapter11HUnitEditor'),
  getItem('Chapter 12 Armoury Editor', 'FE7/Chapter12ArmouryEditor'),
  getItem('Chapter 12 Shop Editor', 'FE7/Chapter12ShopEditor'),
  getItem('Chapter 12 Table Editor', 'FE7/Chapter12TableEditor'),
  getItem('Chapter 12 Unit Editor', 'FE7/Chapter12UnitEditor'),
  getItem('Chapter 13 Armoury Editor', 'FE7/Chapter13ArmouryEditor'),
  getItem('Chapter 13 Seize Editor', 'FE7/Chapter13SeizeEditor'),
  getItem('Chapter 13 Shop Editor', 'FE7/Chapter13ShopEditor'),
  getItem('Chapter 13 Table Editor', 'FE7/Chapter13TableEditor'),
  getItem('Chapter 13 Unit Editor', 'FE7/Chapter13UnitEditor'),
  getItem('Chapter 13x Table Editor', 'FE7/Chapter13xTableEditor'),
  getItem('Chapter 13x Unit Editor', 'FE7/Chapter13xUnitEditor'),
  getItem('Chapter 14 Armoury Editor', 'FE7/Chapter14ArmouryEditor'),
  getItem('Chapter 14 Shop Editor', 'FE7/Chapter14ShopEditor'),
  getItem('Chapter 14 Unit Editor', 'FE7/Chapter14UnitEditor'),
  getItem('Chapter 15 Seize Editor', 'FE7/Chapter15SeizeEditor'),
  getItem('Chapter 15 Table Editor', 'FE7/Chapter15TableEditor'),
  getItem('Chapter 15 Unit Editor', 'FE7/Chapter15UnitEditor'),
  getItem('Chapter 16 Left Armoury Editor', 'FE7/Chapter16LeftArmouryEditor'),
  getItem('Chapter 16 Right Armoury Editor', 'FE7/Chapter16RightArmouryEditor'),
  getItem('Chapter 16 Seize Editor', 'FE7/Chapter16SeizeEditor'),
  getItem('Chapter 16 Shop Editor', 'FE7/Chapter16ShopEditor'),
  getItem('Chapter 16 Table Editor', 'FE7/Chapter16TableEditor'),
  getItem('Chapter 16 Unit Editor', 'FE7/Chapter16UnitEditor'),
  getItem('Chapter 17 Table Editor', 'FE7/Chapter17TableEditor'),
  getItem('Chapter 17 Unit Editor', 'FE7/Chapter17UnitEditor'),
  getItem('Chapter 17x Shop Editor', 'FE7/Chapter17xShopEditor'),
  getItem('Chapter 17x Table Editor', 'FE7/Chapter17xTableEditor'),
  getItem('Chapter 17x Unit Editor', 'FE7/Chapter17xUnitEditor'),
  getItem('Chapter 18 Armoury Editor', 'FE7/Chapter18ArmouryEditor'),
  getItem('Chapter 18 Shop Editor', 'FE7/Chapter18ShopEditor'),
  getItem('Chapter 18 Table Editor', 'FE7/Chapter18TableEditor'),
  getItem('Chapter 18 Unit Editor', 'FE7/Chapter18UnitEditor'),
  getItem('Chapter 18x Seize Editor', 'FE7/Chapter18xSeizeEditor'),
  getItem('Chapter 19 Seize Editor', 'FE7/Chapter19SeizeEditor'),
  getItem('Chapter 19 Table Editor', 'FE7/Chapter19TableEditor'),
  getItem('Chapter 19 Unit Editor', 'FE7/Chapter19UnitEditor'),
  getItem('Chapter 19x Table Editor', 'FE7/Chapter19xTableEditor'),
  getItem('Chapter 19x Unit Editor', 'FE7/Chapter19xUnitEditor'),
  getItem('Chapter 19xx Table Editor', 'FE7/Chapter19xxTableEditor'),
  getItem('Chapter 19xx Unit Editor', 'FE7/Chapter19xxUnitEditor'),
  getItem('Chapter 2 Seize Editor', 'FE7/Chapter2SeizeEditor'),
  getItem('Chapter 2 Unit Editor', 'FE7/Chapter2UnitEditor'),
  getItem('Chapter 20 Secret1 Editor', 'FE7/Chapter20Secret1Editor'),
  getItem('Chapter 20 Secret2 Editor', 'FE7/Chapter20Secret2Editor'),
  getItem('Chapter 20 Table Editor', 'FE7/Chapter20TableEditor'),
  getItem('Chapter 20 Unit Editor', 'FE7/Chapter20UnitEditor'),
  getItem('Chapter 20/21 Table Editor', 'FE7/21TableEditor'),
  getItem('Chapter 21 Left Armoury Editor', 'FE7/Chapter21LeftArmouryEditor'),
  getItem('Chapter 21 Left Shop Editor', 'FE7/Chapter21LeftShopEditor'),
  getItem('Chapter 21 Right Armoury Editor', 'FE7/Chapter21RightArmouryEditor'),
  getItem('Chapter 21 Right Shop Editor', 'FE7/Chapter21RightShopEditor'),
  getItem('Chapter 21 Unit Editor', 'FE7/Chapter21UnitEditor'),
  getItem('Chapter 21/22 Table Editor', 'FE7/22TableEditor'),
  getItem('Chapter 22 Secret Editor', 'FE7/Chapter22SecretEditor'),
  getItem('Chapter 22 Unit Editor', 'FE7/Chapter22UnitEditor'),
  getItem('Chapter 22/23 Table Editor', 'FE7/23TableEditor'),
  getItem('Chapter 22x/23x Table Editor', 'FE7/23xTableEditor'),
  getItem('Chapter 23 Unit Editor', 'FE7/Chapter23UnitEditor'),
  getItem('Chapter 23/24 Linus Table Editor', 'FE7/24LinusTableEditor'),
  getItem('Chapter 23/24 Lloyd Table Editor', 'FE7/24LloydTableEditor'),
  getItem('Chapter 23x Unit Editor', 'FE7/Chapter23xUnitEditor'),
  getItem('Chapter 24 Linus Unit Editor', 'FE7/Chapter24LinusUnitEditor'),
  getItem('Chapter 24 Lloyd Unit Editor', 'FE7/Chapter24LloydUnitEditor'),
  getItem('Chapter 24/26 Table Editor', 'FE7/26TableEditor'),
  getItem('Chapter 24A Left Armoury Editor', 'FE7/Chapter24ALeftArmouryEditor'),
  getItem('Chapter 24A Left Shop Editor', 'FE7/Chapter24ALeftShopEditor'),
  getItem('Chapter 24A Right Armoury Editor', 'FE7/Chapter24ARightArmouryEditor'),
  getItem('Chapter 24A Right Shop Editor', 'FE7/Chapter24ARightShopEditor'),
  getItem('Chapter 24A Secret Editor', 'FE7/Chapter24ASecretEditor'),
  getItem('Chapter 24B Left Armoury Editor', 'FE7/Chapter24BLeftArmouryEditor'),
  getItem('Chapter 24B Left Shop Editor', 'FE7/Chapter24BLeftShopEditor'),
  getItem('Chapter 24B Right Armoury Editor', 'FE7/Chapter24BRightArmouryEditor'),
  getItem('Chapter 24B Right Shop Editor', 'FE7/Chapter24BRightShopEditor'),
  getItem('Chapter 24B Secret Editor', 'FE7/Chapter24BSecretEditor'),
  getItem('Chapter 25 Armoury Editor', 'FE7/Chapter25ArmouryEditor'),
  getItem('Chapter 25 Cutscene Unit Editor', 'FE7/Chapter25CutsceneUnitEditor'),
  getItem('Chapter 25 Shop Editor', 'FE7/Chapter25ShopEditor'),
  getItem('Chapter 25 Unit Editor', 'FE7/Chapter25UnitEditor'),
  getItem('Chapter 25-27 Jerme Table Editor', 'FE7/Chapter2527JermeTableEditor'),
  getItem('Chapter 25-27 Kenneth Table Editor', 'FE7/Chapter2527KennethTableEditor'),
  getItem('Chapter 25H Table Editor', 'FE7/Chapter25HTableEditor'),
  getItem('Chapter 26 Armoury Editor', 'FE7/Chapter26ArmouryEditor'),
  getItem('Chapter 26 Shop Editor', 'FE7/Chapter26ShopEditor'),
  getItem('Chapter 26 Unit Editor', 'FE7/Chapter26UnitEditor'),
  getItem('Chapter 26/28 Table Editor', 'FE7/28TableEditor'),
  getItem('Chapter 26x/28x Table Editor', 'FE7/28xTableEditor'),
  getItem('Chapter 27 Jerme Unit Editor', 'FE7/Chapter27JermeUnitEditor'),
  getItem('Chapter 27 Kenneth Unit Editor', 'FE7/Chapter27KennethUnitEditor'),
  getItem('Chapter 27/29 Table Editor', 'FE7/29TableEditor'),
  getItem('Chapter 28 Eliwood Table Editor', 'FE7/Chapter28EliwoodTableEditor'),
  getItem('Chapter 28 Unit Editor', 'FE7/Chapter28UnitEditor'),
  getItem('Chapter 28x Unit Editor', 'FE7/Chapter28xUnitEditor'),
  getItem('Chapter 29 Armoury Editor', 'FE7/Chapter29ArmouryEditor'),
  getItem('Chapter 29 Shop Editor', 'FE7/Chapter29ShopEditor'),
  getItem('Chapter 29 Unit Editor', 'FE7/Chapter29UnitEditor'),
  getItem('Chapter 29/31 Table Editor', 'FE7/31TableEditor'),
  getItem('Chapter 29x/31x Table Editor', 'FE7/31xTableEditor'),
  getItem('Chapter 3 Armoury Editor', 'FE7/Chapter3ArmouryEditor'),
  getItem('Chapter 3 Table Editor', 'FE7/Chapter3TableEditor'),
  getItem('Chapter 3 Unit Editor', 'FE7/Chapter3UnitEditor'),
  getItem('Chapter 30 Eliwood Unit Editor', 'FE7/Chapter30EliwoodUnitEditor'),
  getItem('Chapter 30 Hector Table Editor', 'FE7/Chapter30HectorTableEditor'),
  getItem('Chapter 30 Hector Unit Editor', 'FE7/Chapter30HectorUnitEditor'),
  getItem('Chapter 30/32 Table Editor', 'FE7/32TableEditor'),
  getItem('Chapter 31 Secret Editor', 'FE7/Chapter31SecretEditor'),
  getItem('Chapter 31 Unit Editor', 'FE7/Chapter31UnitEditor'),
  getItem('Chapter 31x Bottom Armoury Editor', 'FE7/Chapter31xBottomArmouryEditor'),
  getItem('Chapter 31x Left Shop Editor', 'FE7/Chapter31xLeftShopEditor'),
  getItem('Chapter 31x Right Shop Editor', 'FE7/Chapter31xRightShopEditor'),
  getItem('Chapter 31x tLeft Armoury Editor', 'FE7/Chapter31xtLeftArmouryEditor'),
  getItem('Chapter 31x tMiddle Armoury Editor', 'FE7/Chapter31xtMiddleArmouryEditor'),
  getItem('Chapter 31x tRight Armoury Editor', 'FE7/Chapter31xtRightArmouryEditor'),
  getItem('Chapter 31x Unit Editor', 'FE7/Chapter31xUnitEditor'),
  getItem('Chapter 32 Secret Editor', 'FE7/Chapter32SecretEditor'),
  getItem('Chapter 32 Unit Editor', 'FE7/Chapter32UnitEditor'),
  getItem('Chapter 32x Table Editor', 'FE7/Chapter32xTableEditor'),
  getItem('Chapter 32x Unit Editor', 'FE7/Chapter32xUnitEditor'),
  getItem('Chapter 4 Table Editor', 'FE7/Chapter4TableEditor'),
  getItem('Chapter 4 Unit Editor', 'FE7/Chapter4UnitEditor'),
  getItem('Chapter 5 Armoury Editor', 'FE7/Chapter5ArmouryEditor'),
  getItem('Chapter 5 Table Editor', 'FE7/Chapter5TableEditor'),
  getItem('Chapter 5 Unit Editor', 'FE7/Chapter5UnitEditor'),
  getItem('Chapter 6 Table Editor', 'FE7/Chapter6TableEditor'),
  getItem('Chapter 6 Unit Editor', 'FE7/Chapter6UnitEditor'),
  getItem('Chapter 7 Shop Editor', 'FE7/Chapter7ShopEditor'),
  getItem('Chapter 7 Table Editor', 'FE7/Chapter7TableEditor'),
  getItem('Chapter 7 Unit Editor', 'FE7/Chapter7UnitEditor'),
  getItem('Chapter 7x Table Editor', 'FE7/Chapter7xTableEditor'),
  getItem('Chapter 7x Unit Editor', 'FE7/Chapter7xUnitEditor'),
  getItem('Chapter 8 Armoury Editor', 'FE7/Chapter8ArmouryEditor'),
  getItem('Chapter 8 Table Editor', 'FE7/Chapter8TableEditor'),
  getItem('Chapter 8 Unit Editor', 'FE7/Chapter8UnitEditor'),
  getItem('Chapter 9 Seize Editor', 'FE7/Chapter9SeizeEditor'),
  getItem('Chapter 9 Table Editor', 'FE7/Chapter9TableEditor'),
  getItem('Chapter 9 Unit Editor', 'FE7/Chapter9UnitEditor'),
  getItem('Chapter Data Editor (FE7) -', 'FE7/ChapterDataEditorFE7'),
  getItem('Chapter Final Boss Unit Editor', 'FE7/ChapterFinalBossUnitEditor'),
  getItem('Chapter Final Unit Editor', 'FE7/ChapterFinalUnitEditor'),
  getItem('Chapter Unit Editor', 'FE7/ChapterUnitEditor'),
  getItem('Custom Battle Sprite Table Editor', 'FE7/CustomBattleSpriteTableEditor'),
  getItem('Custom Shop Editor', 'FE7/CustomShopEditor'),
  getItem('Death quote editor part 1', 'FE7/Deathquoteeditorpart1'),
  getItem('Death quote editor part 2', 'FE7/Deathquoteeditorpart2'),
  getItem('Escape Tile Pointer Editor', 'FE7/EscapeTilePointerEditor'),
  getItem('FE 7 Animation Pointer Table Editor', 'FE7/AnimationPointerTableEditor'),
  getItem('FE 7 Arena class editor', 'FE7/Arenaclasseditor'),
  getItem('FE 7 Crit bonus editor', 'FE7/Critbonuseditor'),
  getItem('FE 7 Event table references', 'FE7/Eventtablereferences'),
  getItem('FE 7 Map sprite pointer table editor', 'FE7/Mapspritepointertableeditor'),
  getItem('FE 7 Promotion Level Editor', 'FE7/PromotionLevelEditor'),
  getItem('FE 7 Tutorial Editor', 'FE7/TutorialEditor'),
  getItem('FE 7 World Map Data References', 'FE7/WorldMapDataReferences'),
  getItem('FE7 Afa Drops Boost Editor', 'FE7/AfaDropsBoostEditor'),
  getItem('FE7 Battle Animation Editor', 'FE7/BattleAnimationEditor'),
  getItem('FE7 Battle BG Editor', 'FE7/BattleBGEditor'),
  getItem('FE7 Battle Palette Reference', 'FE7/BattlePaletteReference'),
  getItem('FE7 Beta Character Editor', 'FE7/BetaCharacterEditor'),
  getItem('FE7 Beta Class Editor', 'FE7/BetaClassEditor'),
  getItem('FE7 Beta Item Editor', 'FE7/BetaItemEditor'),
  getItem('FE7 Boss Music Editor', 'FE7/BossMusicEditor'),
  getItem('FE7 CG Editor', 'FE7/CGEditor'),
  getItem('FE7 Ch 11H Chest Editor', 'FE7/Ch11HChestEditor'),
  getItem('FE7 Ch 15 Chest Editor', 'FE7/Ch15ChestEditor'),
  getItem('FE7 Ch 17 Chest Editor', 'FE7/Ch17ChestEditor'),
  getItem('FE7 Ch 19x Chest Editor', 'FE7/Ch19xChestEditor'),
  getItem('FE7 Ch 19xx Chest Editor', 'FE7/Ch19xxChestEditor'),
  getItem('FE7 Ch 20 Chest Editor', 'FE7/Ch20ChestEditor'),
  getItem('FE7 Ch 22 Chest Editor', 'FE7/Ch22ChestEditor'),
  getItem('FE7 Ch 23x Chest Editor', 'FE7/Ch23xChestEditor'),
  getItem('FE7 Ch 26 Chest Editor', 'FE7/Ch26ChestEditor'),
  getItem('FE7 Ch 27A Chest Editor', 'FE7/Ch27AChestEditor'),
  getItem('FE7 Ch 27B Chest Editor', 'FE7/Ch27BChestEditor'),
  getItem('FE7 Ch 28 Chest Editor', 'FE7/Ch28ChestEditor'),
  getItem('FE7 Ch 28x Chest Editor', 'FE7/Ch28xChestEditor'),
  getItem('FE7 Ch 29 Chest Editor', 'FE7/Ch29ChestEditor'),
  getItem('FE7 Ch 30H Chest Editor', 'FE7/Ch30HChestEditor'),
  getItem('FE7 Ch 31 Chest Editor', 'FE7/Ch31ChestEditor'),
  getItem('FE7 Ch 32x Chest Editor', 'FE7/Ch32xChestEditor'),
  getItem('FE7 Ch 6 Chest Editor', 'FE7/Ch6ChestEditor'),
  getItem('FE7 Ch 7x Chest Editor', 'FE7/Ch7xChestEditor'),
  getItem('FE7 Ch Final Chest Editor', 'FE7/ChFinalChestEditor'),
  getItem('FE7 Ch Unknown2 Chest Editor', 'FE7/ChUnknown2ChestEditor'),
  getItem('FE7 Character Editor', 'FE7/CharacterEditor'),
  getItem('FE7 Class Editor', 'FE7/ClassEditor'),
  getItem('FE7 Convo BG Editor', 'FE7/ConvoBGEditor'),
  getItem('FE7 Custom Battle Animation Editor', 'FE7/CustomBattleAnimationEditor'),
  getItem('FE7 Custom Item Animation List - Works only with an expanded ROM!', 'FE7/CustomItemAnimationListWorksonlywithanexpandedROM'),
  getItem('FE7 Custom Promotion Pointer Editor', 'FE7/CustomPromotionPointerEditor'),
  getItem('FE7 Fallen Contract Promotion Editor', 'FE7/FallenContractPromotionEditor'),
  getItem('FE7 Heaven Seal Promotion Editor', 'FE7/HeavenSealPromotionEditor'),
  getItem('FE7 Item Animation Reference Pointer - Expanded ROM required', 'FE7/ItemAnimationReferencePointerExpandedROMrequired'),
  getItem('FE7 Item Editor', 'FE7/ItemEditor'),
  getItem('FE7 Luck Cap Editor [P1]', 'FE7/LuckCapEditorP1'),
  getItem('FE7 Luck Cap Editor [P2]', 'FE7/LuckCapEditorP2'),
  getItem('FE7 Music Array Editor', 'FE7/MusicArrayEditor'),
  getItem('FE7 Ocean Seal Promotion Editor', 'FE7/OceanSealPromotionEditor'),
  getItem('FE7 Portrait Editor', 'FE7/PortraitEditor'),
  getItem('FE7 Promotion Item Editor', 'FE7/PromotionItemEditor'),
  getItem('FE7 Sound Room Editor', 'FE7/SoundRoomEditor'),
  getItem('FE7 Spell Association Editor', 'FE7/SpellAssociationEditor'),
  getItem('FE7 Standing map sprite editor', 'FE7/Standingmapspriteeditor'),
  getItem('FE7 Stat Bonuses Editor', 'FE7/StatBonusesEditor'),
  getItem('FE7 Support Pointer Editor', 'FE7/SupportPointerEditor'),
  getItem('FE7 Terrain Stat Editor', 'FE7/TerrainStatEditor'),
  getItem('FE7 Vulnerary Editor', 'FE7/VulneraryEditor'),
  getItem('Final Chapter (2) Table Editor', 'FE7/FinalChapter2TableEditor'),
  getItem('Final Chapter Table Editor', 'FE7/FinalChapterTableEditor'),
  getItem('Fire Emblem 7 (Paired) Endings Editor ', 'FE7/FireEmblem7PairedEndingsEditor'),
  getItem('Fire Emblem 7 Support compatibility Editor ', 'FE7/FireEmblem7SupportcompatibilityEditor'),
  getItem('Fire Emblem 7 Support Convo Availability Editor ', 'FE7/FireEmblem7SupportConvoAvailabilityEditor'),
  getItem('Hawkeye Custom Animation Editor', 'FE7/HawkeyeCustomAnimationEditor'),
  getItem('Hero Raven Custom Animation Editor', 'FE7/HeroRavenCustomAnimationEditor'),
  getItem('Isadora Custom Animation Editor', 'FE7/IsadoraCustomAnimationEditor'),
  getItem('Level Cap Editor', 'FE7/LevelCapEditor'),
  getItem('Linus (1) Custom Animation Editor', 'FE7/Linus1CustomAnimationEditor'),
  getItem('Linus (2) Custom Animation Editor', 'FE7/Linus2CustomAnimationEditor'),
  getItem('Linus (3) Custom Animation Editor', 'FE7/Linus3CustomAnimationEditor'),
  getItem('Lloyd (1) Custom Animation Editor', 'FE7/Lloyd1CustomAnimationEditor'),
  getItem('Lloyd (2) Custom Animation Editor', 'FE7/Lloyd2CustomAnimationEditor'),
  getItem('Lloyd (3) Custom Animation Editor', 'FE7/Lloyd3CustomAnimationEditor'),
  getItem('Lucius Bishop Custom Animation Editor', 'FE7/LuciusBishopCustomAnimationEditor'),
  getItem('Lucius Monk Custom Animation Editor', 'FE7/LuciusMonkCustomAnimationEditor'),
  getItem('Lyn\'s Ending Editor', 'FE7/LynsEndingEditor'),
  getItem('Movement Type Editor (FE7) - Credit to Fire Blazer', 'FE7/MovementTypeEditorFE7CredittoFireBlazer'),
  getItem('Myrmidon Guy Custom Animation Editor', 'FE7/MyrmidonGuyCustomAnimationEditor'),
  getItem('Nino Sage Custom Animation Editor', 'FE7/NinoSageCustomAnimationEditor'),
  getItem('Prologue Seize Editor', 'FE7/PrologueSeizeEditor'),
  getItem('Prologue Unit Editor', 'FE7/PrologueUnitEditor'),
  getItem('Specified Battle Convo Editor (FE7) -', 'FE7/SpecifiedBattleConvoEditorFE7'),
  getItem('Stuff', 'FE7/Stuff'),
  getItem('Support Bonus Editor', 'FE7/SupportBonusEditor'),
  getItem('Swordmaster Guy Custom Animation Editor', 'FE7/SwordmasterGuyCustomAnimationEditor'),
  getItem('Thief Legault Custom Animation Editor', 'FE7/ThiefLegaultCustomAnimationEditor'),
  getItem('Triangle attack Convo -', 'FE7/TriangleattackConvo'),
  getItem('Turn Menu table', 'FE7/TurnMenutable'),
  getItem('Unit Menu table', 'FE7/UnitMenutable'),
  getItem('Unknown18 Unit Editor', 'FE7/Unknown18UnitEditor'),
  getItem('Unspecified Battle Convo Editor (FE7) -', 'FE7/UnspecifiedBattleConvoEditorFE7'),
]);

export default FE7Items;
